function isRemoteOrSpecialPath(path) {
  return /^(https?:)?\/\//.test(path) || /^(data|blob):/.test(path);
}

let localImageContext = null;

try {
  localImageContext = require.context('../asset/images', true, /\.(png|jpe?g|gif|webp|svg)$/);
} catch {
  localImageContext = null;
}

function toLocalImageKey(path) {
  const normalizedPath = String(path || '')
    .trim()
    .replace(/^\.?\//, '')
    .replace(/^src\//, '');

  if (normalizedPath.startsWith('asset/images/')) {
    return `./${normalizedPath.slice('asset/images/'.length)}`;
  }

  if (normalizedPath.startsWith('images/')) {
    return `./${normalizedPath.slice('images/'.length)}`;
  }

  return `./${normalizedPath}`;
}

function resolveLocalImage(path) {
  if (!localImageContext) {
    return '';
  }

  try {
    return localImageContext(toLocalImageKey(path));
  } catch {
    return '';
  }
}

export function resolveImageSrc(image) {
  const path = String(image || '').trim();

  if (!path) {
    return '';
  }

  if (isRemoteOrSpecialPath(path)) {
    return path;
  }

  const localImageSrc = resolveLocalImage(path);

  if (localImageSrc) {
    return localImageSrc;
  }

  if (path.startsWith('/')) {
    return path;
  }

  const basePath = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
  const normalizedPath = path.replace(/^\.?\//, '');

  return `${basePath}/${normalizedPath}`;
}
